<ambita-cadastre-report-error>
  <div show="{ lookupData.error }">
    <span class="icon icon-exclamation-triangle"></span>
    <span>{ lookupData.error }</span>
  </div>
  <script>
    import { init } from './cadastreReportErrorController';

    init(this);
  </script>
</ambita-cadastre-report-error>
